import React, { Fragment, useState } from 'react';
import {
  Button,
  Form,
  Row,
  Col,
  Container,
  Alert,
} from '@themesberg/react-bootstrap';
import { post } from '../../../services/back.service';
import { getBase64 } from '../../../utils/functions';

function CriticalPlatesForm({ plate, addTmpLog }) {
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [infoForm, setForm] = useState({
    description: '',
    images: [],
  });

  const updateImages = (name, value) => {
    const tmImages = infoForm.images;
    const index = tmImages.findIndex((e) => e.name === name);
    if (index >= 0) {
      tmImages[index].base64 = value.base64;
      tmImages[index].upload = true;
    } else {
      tmImages.push({
        name,
        base64: value.base64,
        upload: true
      });
    }
    setForm({ ...infoForm, images: tmImages });
  };

  const handleForm = ({ target }) => {
    setForm({ ...infoForm, [target.name]: target.value });
  };

  const saveForm = async (e) => {
    e.preventDefault();
    const body = { plate, ...infoForm };
    let respo;
    let msg;

    respo = await post('/critical/create', body);
    msg = 'Registro agregado.';

    if (respo.success) {
      setAlert({
        show: true,
        message: msg, //'Registro agregado.',
        type: 'success'
      });

      addTmpLog({
        id_c: respo.data.id,
        descripcion: infoForm.description,
        responsable: 'Usuario Actual'
      })
      setForm({
        description: '',
        images: []
      });

    } else {
      setAlert({
        show: true,
        message: respo.message,
        type: 'danger'
      });
    }
  };

  const showConvertImage = async (e, name) => {
    const currentFile = e.target.files[0];
    const fileProcess = await getBase64(currentFile, name);
    updateImages(name, fileProcess);
  };


  const getCurrentImage = (name) => {
    const image = infoForm.images.find((e) => e.name === name);
    if (image) {
      return image.base64
    } else {
      return ''
    }
  }

  return (
    <Fragment>
      <Container>
        {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
        <Form id='form_add_log' onSubmit={(e) => saveForm(e)}>
          <Row>
            <Col>
              <Form.Label htmlFor="obs_additonal_1">DESCRIPCION</Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="description"
                value={infoForm.description}
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="nombre">IMAGENES</Form.Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <img
                  alt="sin imagen"
                  width={'250px'}
                  src={getCurrentImage('image0')}
                />
                <Form.Control
                  type="file"
                  id="image0"
                  name="image0"
                  onChange={(e) => { showConvertImage(e, 'image0'); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <img
                  alt="sin imagen"
                  width={'250px'}
                  src={getCurrentImage('image1')}
                />
                <Form.Control
                  type="file"
                  id="image1"
                  name="image1"
                  onChange={(e) => { showConvertImage(e, 'image1'); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <img
                  alt="sin imagen"
                  width={'250px'}
                  src={getCurrentImage('image2')}
                />
                <Form.Control
                  type="file"
                  id="image2"
                  name="image2"
                  onChange={(e) => { showConvertImage(e, 'image2'); }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="text-center m-3">
            <Col>
              <Button
                type="submit"
                variant="primary"
              >
                Guardar Informacion
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Fragment>
  );
}

export default CriticalPlatesForm;
